import './search-results.styl';

import React from 'react';
import SearchResultsItem from './SearchResultsItem';

const SearchResults = ({results, translateResults, useragent, locale}) =>
  <div className="search-results">
    {results && results.map((item, key) =>
      <div className="search-results__item" key={key}>
        {translateResults && item.htmlTitleTranslated &&
          <SearchResultsItem
            link={item.link}
            htmlTitle={item.htmlTitleTranslated}
            htmlSnippet={item.htmlSnippetTranslated}
            displayLink={item.displayLink}
            onHover={false}
            useragent={useragent}
            locale={locale}
          />
        }
        <SearchResultsItem
          link={item.link}
          htmlTitle={item.htmlTitle}
          htmlSnippet={item.htmlSnippet}
          displayLink={item.displayLink}
          onHover={translateResults && !!item.htmlTitleTranslated}
          useragent={useragent}
          locale={locale}
        />
      </div>
    )}
  </div>;

SearchResults.propTypes = {
  results: React.PropTypes.object,
  useragent: React.PropTypes.object,
  locale: React.PropTypes.string,
  translateResults: React.PropTypes.bool
};

export default SearchResults;



// WEBPACK FOOTER //
// ./src/client/components/search-results/SearchResults.js